import { apiClient } from '~api/client';
import type { Blast, BlastResponse } from './blast.types';

type CoordSystem = 'local' | 'wgs';

type BlastQueryParams = {
  /** Filter by blast name */
  name?: string;
  /** Partial pattern name match (e.g. "TDG4") */
  query?: string;
  /** Coordinate reference system */
  crs?: CoordSystem;
  /** Filter by mine code (e.g. "hd4") */
  mine_code?: string;
  /** Page number for pagination */
  page?: number;
  /** Number of results per page */
  page_size?: number;
  /** Filter by current active drill domains. True = with drill domains, false = without, omitted = no filter. */
  has_drill_domains?: boolean;
  /** Filter by successful completed optimisations. True = has optimisations, false = has none, omitted = no filter. */
  has_optimisations?: boolean;
  /** Filter by failed latest jobs. True = latest optimisation or hardness job failed, false = neither failed, omitted = no filter. */
  needs_attention?: boolean;
};

type BlastPolygonsQueryParams = {
  /** Filter by reduced level (elevation), comma-separated range (e.g. "680,700") */
  rl?: string;
  /** Filter by mine code (e.g. "hd4") */
  mine_code?: string;
  /** Filter by pit name (e.g. "TDG4") */
  pit?: string;
  /** Filter by blast name */
  name?: string;
  /** Coordinate reference system */
  crs?: CoordSystem;
  /** ISO 8601 start date filter */
  since?: string;
  /** ISO 8601 end date filter */
  until?: string;
  /** Page number for pagination */
  page?: number;
  /** Number of results per page */
  page_size?: number;
};

const blastService = {
  getBlasts: async (params?: BlastQueryParams): Promise<Blast[]> => {
    const { crs, ...rest } = params || {};
    const response = await apiClient.get<BlastResponse>('/blasts/', {
      params: { crs: crs ?? 'local', ...rest },
    });
    return response.data.blasts;
  },
};

export { type BlastPolygonsQueryParams, type BlastQueryParams, blastService };
